import React from 'react';
import { formatSavedTime } from '../../hooks/useAutosave';

export interface AutosaveIndicatorProps {
  saving: boolean;
  lastSavedAt: Date | null;
  stopped?: boolean;
  hasError?: boolean;
}

/** Small "Saved 2:05 PM" status used next to a draft form's status pill */
const AutosaveIndicator: React.FC<AutosaveIndicatorProps> = ({ saving, lastSavedAt, stopped = false, hasError = false }) => {
  let text: string | null = null;
  let className = 'text-slate-500';
  if (saving) {
    text = 'Saving...';
  } else if (stopped) {
    text = 'Autosave paused';
    className = 'text-amber-700';
  } else if (hasError) {
    text = 'Autosave failed';
    className = 'text-red-700';
  } else if (lastSavedAt) {
    text = `Saved ${formatSavedTime(lastSavedAt)}`;
  }
  if (!text) return null;
  return (
    <span className={`text-xs whitespace-nowrap ${className}`} role="status" aria-live="polite">
      {text}
    </span>
  );
};

export default AutosaveIndicator;
